import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ModalNotificationsComponent} from "./components/modal-notifications.component";
import {
  PersonalInfirmationComponentsModule
} from "../views/personal-information/personal-infirmation-components.module";
import {NetcardSharedModule} from "../shared";
import {I18nModule} from "@twino/core-lib";

@NgModule({
  declarations: [ModalNotificationsComponent],
  exports: [ModalNotificationsComponent],
  imports: [
    CommonModule,
    PersonalInfirmationComponentsModule,
    NetcardSharedModule,
    I18nModule
  ],
})
export class ModalNotificationsModule { }
